// Leave modal

( function($, waTheme) {

    var LeaveModal = (function ($) {

        LeaveModal = function (options) {
            var that = this;

            // DOM
            that.$wrapper = options['$wrapper'];

            // VARS
            that.options = that.$wrapper.data("modal");

            // DYNAMIC VARS
            that.show = true;

            // EVENTS
            that.init();
        };

        LeaveModal.prototype.init = function () {
            var that = this;

            if ($.cookie(that.options["cookie-name"]) === undefined) {
                $(document).mouseleave(function () {
                    if (that.show === true) {
                        // show
                        that.$wrapper.modal("show");

                        // set cookie
                        var date = new Date();
                        date.setTime(date.getTime() + (that.options["cookie-time"] * 60 * 60 * 1000));
                        $.cookie(that.options["cookie-name"], "true", {expires: date, path: "/"});

                        // disabled
                        that.show = false;
                    }
                });
            }
        }

        return LeaveModal;

    })($);

    waTheme.init.site.LeaveModal = LeaveModal;

    var $leaveModal = $(".b-leave-modal");
    if ($leaveModal.length) {
        new window.waTheme.init.site.LeaveModal({
            $wrapper: $leaveModal
        });
    }

})(jQuery, window.waTheme);